var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadOnlyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.045,
    height: 18,
    viewBox: "0 0 18.045 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hide_18px",
    transform: "translate(-968 -168)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 18,
    height: 18,
    transform: "translate(968 168)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(968 167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M1,9.925S3.963,4,9.147,4s8.147,5.925,8.147,5.925-2.963,5.925-8.147,5.925S1,9.925,1,9.925Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(7.147 7.925)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadOnlyIcon);
export default __webpack_public_path__ + "static/media/read-only-icon.ad6632d75142b84e34bfcfd47b430047.svg";
export { ForwardRef as ReactComponent };